import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import ComposeOutlookItemDialog, { ComposeOutlookItemDialogProps } from './ComposeOutlookItemDialog'
import { DocumentOverviewItemDto, IDocumentOverviewItemDto } from '../../../config/documentConfig'
import { getDriveItemDownloadUrl } from '../../../helpers/documentHelper'
import { outlookDisplayNewMessageForm } from '../../../helpers/outlookHelper'
import useAxios from '../../../hooks/useAxios'
import { useTranslation } from 'react-i18next'
import AsyncResultStatus = Office.AsyncResultStatus
import EmailAddressDetails = Office.EmailAddressDetails
import MessageFormAttachment = Office.MessageFormAttachment

export type ComposeEmailDialogProps = Omit<ComposeOutlookItemDialogProps, 'onCompose' | 'submitText'> & {
    documents?: DocumentOverviewItemDto[]
    callback?: () => void
}

export default function ComposeEmailDialog(props: ComposeEmailDialogProps): ReactElement {
    const axios = useAxios()
    const { t: translate } = useTranslation()

    const [attachments, setAttachments] = useState<Promise<MessageFormAttachment>[]>([])

    useEffect(() => {
        setAttachments(
            (props.documents || []).map((item: IDocumentOverviewItemDto) =>
                getDriveItemDownloadUrl(item.id, axios).then(downloadUrl => ({
                    type: 'file',
                    name: item.name,
                    url: downloadUrl,
                    isInline: false,
                })),
            ),
        )
    }, [props.documents])

    return (
        <ComposeOutlookItemDialog
            submitText={translate('action.create.email')}
            dialogContentProps={{ title: translate('action.create.email') }}
            {...props}
            onCompose={async (toRecipients: EmailAddressDetails[], subject: string) => {
                Promise.all(attachments).then(resolvedAttachments => {
                    outlookDisplayNewMessageForm(
                        {
                            toRecipients,
                            attachments: resolvedAttachments,
                            subject,
                        },
                        (asyncResult?: Office.AsyncResult<void>) => {
                            if (!asyncResult || asyncResult?.status === AsyncResultStatus.Succeeded) {
                                props.callback?.()
                                props.onDismiss()
                            }
                        },
                    )
                })
            }}
        />
    )
}
